<app-loader [loading]="isLoading || refundService.isLoading" [overlay]="true"></app-loader>
<div class="body-2 text-muted" *ngIf="!refundService.refundEvents?.length && !isLoading && !refundService.isLoading">
  <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
  {{ 'general.api_refund_empty' | translate }}
</div>
<div class="content-with-sidebar with-footer" *ngIf="refundService.refundEvents?.length">
  <div class="content">
    <div [ngClass]="{'mobile-hidden': modalIsOpened}" class="heading-1">{{ 'general.api_refund' | translate }}</div>
    <div *ngIf="modalIsOpened" class="mobile flex space-between max-width">
      <div class="heading-1">{{ 'general.api_refund_proceed' | translate }}</div>
      <div>
        <button mat-button class="icon-button" (click)="undoRefund()">
          <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
        </button>
      </div>
    </div>
    <mat-card appearance="outlined" [ngClass]="{'mobile-hidden': modalIsOpened}">
      <app-data-table *ngIf="tableConfig" [(config)]="tableConfig" [(data)]="refundService.refundEvents" [useResponsive]="true"
                      [(clickable)]="refundService.clickableTicketIds" [(selected)]="refundService.selectedTicketIds"></app-data-table>
    </mat-card>
    <div class="mobile" *ngIf="modalIsOpened">
      <ng-container *ngTemplateOutlet="refundDetails;"></ng-container>
    </div>
    <footer class="mobile">
      <mat-dialog-actions class="flex flex-column">
        <ng-container *ngIf="!modalIsOpened">
          <div class="flex space-between max-width">
            <div>
              <span class="text-muted">{{ 'general.api_refund_table_items_total' | translate }}</span><br>
              <span class="heading-3 bold">{{ refundService.ticketQuantity*-1 }} {{ 'general.api_cart_table_pcs' | translate }}</span>
            </div>
            <div class="align-right">
              <span class="text-muted">{{ 'general.api_refund_table_items_price_total' | translate }}</span><br>
              <span class="heading-3 bold">
                {{ refundService.cartTotal*-1 | price }}
              </span>
            </div>
          </div>
          <div class="flex max-width">
            <ng-container *ngTemplateOutlet="refundButtons"></ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="modalIsOpened">
          <ng-container *ngTemplateOutlet="refundConfirmButtons"></ng-container>
        </ng-container>
      </mat-dialog-actions>
    </footer>
  </div>
  <div class="sidebar desktop">
    <ng-container *ngTemplateOutlet="refundDetails;"></ng-container>
  </div>
</div>

<ng-template #refundDetails>
  <ng-container *ngIf="modalIsOpened">
    <div class="desktop heading-2">{{ 'general.api_refund_modal_title' | translate }}</div>
    <ng-container *ngIf="hasGiftTickets">
      <div class="heading-5">{{ 'general.api_refund_gift_ticket_added_exception' | translate }}:</div>
      <span class="semi-bold text-secondary">{{ displayActiveGiftTicketIds }}</span>
      <hr>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!modalIsOpened">
    <ng-container *ngIf="(isExchange || !authService.checkPrivileges(Privileges.ADVANCED_REFUND_PROCESS)) && hasGiftTickets">
      <div class="heading-5">{{ 'general.api_refund_gift_ticket_added_exception' | translate }}:</div>
      <span class="semi-bold text-secondary">{{ displayActiveGiftTicketIds }}</span>
      <hr>
    </ng-container>
    <br>
  </ng-container>
  <mat-form-field [ngStyle]="{'display': modalIsOpened && isMobile ? 'block' : modalIsOpened && !isMobile ? 'none' : 'block'}" appearance="outline" class="max-width">
    <mat-label>{{ 'general.api_reports_payment_type' | translate }}</mat-label>
    <mat-select [(ngModel)]="currentPaymentType" [ngModelOptions]="{standalone: true}">
      <mat-select-trigger>{{ ('general.api_cart_' + currentPaymentType) | translate }}</mat-select-trigger>
      <mat-option *ngFor="let paymentType of paymentTypes" [value]="paymentType">
        {{ ('general.api_cart_' + paymentType) | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <table class="totals-table top-spacer">
    <tbody>
      <ng-container *ngTemplateOutlet="refundTotalRow;
        context:{rowName: 'general.api_refund_table_items_total', amount: refundService.ticketQuantity*-1}"></ng-container>
      <ng-container *ngTemplateOutlet="refundTotalRow;
        context:{rowName: 'general.api_refund_table_items_price_total', price: refundService.cartTotal*-1}"></ng-container>
      <ng-container *ngFor="let fee of refundService.cartFees">
        <ng-container *ngTemplateOutlet="refundTotalRow;
          context:{rowName: fee.name, price: fee.total*-1, rowSubtitle: 'general.api_refund_table_refundable'}"></ng-container>
      </ng-container>
      <ng-container *ngFor="let fee of nonRefundableSurcharges">
        <ng-container *ngTemplateOutlet="refundTotalRow;
          context:{rowName: fee.name, price: fee.sum, rowSubtitle: 'general.api_refund_table_nonrefundable'}"></ng-container>
      </ng-container>
      <tr *ngIf="refundService.cartDelivery">
        <th class="align-left">{{ 'general.api_reports_delivery_fee' | translate }}&nbsp;
          ({{refundService.cartDelivery.name | translate}}):</th>
        <td class="align-right"><span class="price">{{ refundService.cartDelivery.price | price }}</span></td>
      </tr>
      <tr *ngFor="let insurance of refundableInsurances">
        <th class="align-left">{{ 'general.api_refund_table_insurance_refundable' | translate }}&nbsp;
          ({{ insurance.insurancePrice | price }}{{insurance.insuranceCount > 1 ? ' x ' + insurance.insuranceCount : ''}}):</th>
        <td class="align-right"><span class="price">{{ -1 * insurance.insurancePrice * insurance.insuranceCount | price }}</span></td>
      </tr>
      <tr *ngFor="let insurance of nonRefundableInsurances">
        <th class="align-left">{{ 'general.api_refund_table_insurance_nonrefundable' | translate }}
          ({{ insurance.insurancePrice | price }}{{insurance.insuranceCount > 1 ? ' x ' + insurance.insuranceCount : ''}}):</th>
        <td class="align-right"><span class="price">{{ insurance.insurancePrice * insurance.insuranceCount | price }}</span></td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <th class="align-left">{{ 'general.api_refund_table_price_total' | translate }}:</th>
        <td class="align-right"><span class="price">{{ refundService.cartTotalSum*-1 | price }}</span></td>
      </tr>
      <ng-container *ngIf="refundService.cart.total?.cashRounding">
        <tr class="prefix">
          <th class="align-left">{{ 'general.api_refund_table_cash_rounding' | translate }}:</th>
          <td class="align-right"><span class="price">{{ refundService.cart.total.cashRounding*-1 | price }}</span></td>
        </tr>
        <tr>
          <th class="align-left">{{ 'general.api_refund_table_price_total_in_cash' | translate }}:</th>
          <td class="align-right"><span class="price">{{ refundService.ticketQuantity ? (refundService.cartTotalSum*-1 + refundService.cart.total.cashRounding*-1 | price) : '-' }}</span></td>
        </tr>
      </ng-container>
    </tfoot>
  </table>
  <br>
  <div class="desktop" *ngIf="modalIsOpened">
    <ng-container *ngTemplateOutlet="refundConfirmButtons"></ng-container>
  </div>
  <ng-container *ngIf="!modalIsOpened">
    <div class="desktop flex flex-grow max-width">
      <ng-container *ngTemplateOutlet="refundButtons"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #refundButtons>
  <button mat-stroked-button color="primary" (click)="cancelRefund()">
    {{ (isExchange ? 'general.api_refund_exchange_cancel' : 'general.api_refund_cancel') | translate }}
  </button>
  <button mat-flat-button color="primary" *ngIf="!isExchange"
          (click)="authService.checkPrivileges(Privileges.ADVANCED_REFUND_PROCESS) ? startRefund() : confirmRefund(actions.Sale)"
          [disabled]="!refundService.cart?.events?.length || (!authService.checkPrivileges(Privileges.ADVANCED_REFUND_PROCESS) && hasGiftTickets) && !canRefund">
    {{ 'general.api_refund_proceed' | translate }}
  </button>
  <button mat-flat-button color="primary" *ngIf="isExchange"
          (click)="confirmRefund(actions.Cart)"
          [disabled]="!refundService.cart?.events?.length || hasGiftTickets && !canRefund">
    {{ 'general.api_refund_proceed' | translate }}
  </button>
</ng-template>
<ng-template #refundConfirmButtons>
  <div class="flex flex-column max-width">
    <button mat-flat-button color="primary" (click)="confirmRefund(actions.None)" [disabled]="!canRefund">
      {{ 'general.api_refund_close' | translate }}
    </button>
    <button mat-stroked-button color="primary" (click)="confirmRefund(actions.Sale)" [disabled]="hasGiftTickets && !canRefund">
      {{ 'general.api_refund_back_to_sale' | translate }}
    </button>
    <button mat-button (click)="undoRefund()">
      {{ 'general.api_refund_undo' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #refundTotalRow let-rowName="rowName" let-amount="amount" let-price="price" let-rowSubtitle="rowSubtitle">
  <tr *ngIf="amount || price">
    <th class="align-left">
      {{ rowName | translateValue }}<ng-container *ngIf="rowSubtitle"> ({{ rowSubtitle | translate }})</ng-container>:
    </th>
    <td class="align-right" *ngIf="amount"><span class="price">{{ amount }} {{ 'general.api_cart_table_pcs' | translate }}</span></td>
    <td class="align-right" *ngIf="price"><span class="price">{{ price | price }}</span></td>
  </tr>
</ng-template>

<!-- Ticket table templates -->
<ng-template #tableTicketId let-item="item">
  <span class="title">{{ item.id }}</span>
  <ng-container *ngIf="findGiftTicket(item.id)">
    <br>{{ 'general.api_refund_gift_ticket' | translate }}
  </ng-container>
</ng-template>
<ng-template #tableMobileTicketId let-item="item">
  <span class="heading-5 text-base">
    {{ 'general.api_cart_table_ticket_id' | translate }}: {{ item.id }}
  </span>
  <ng-container *ngIf="findGiftTicket(item.id)">
    <br>{{ 'general.api_refund_gift_ticket' | translate }}
  </ng-container>
</ng-template>
<ng-template #tableEvent let-item="item">
  <span class="semi-bold">{{ item.title | translateValue }}</span>
  <br>{{ item.venueTitle }}
</ng-template>
<ng-template #tableDate let-item="item">
  <ng-container *ngIf="!item.isSeason">{{ item.eventDate | period: { hasTimeInPeriod: true } }}</ng-container>
</ng-template>
<ng-template #tableTicketType let-item="item">
  {{ item.priceTypeName | translate }}
</ng-template>
<ng-template #tableTicketPrice let-item="item">
  <span class="title semi-bold white-space-no-wrap">-{{ item | ticketPrice:true }}</span>
</ng-template>
